// extracted by mini-css-extract-plugin
export default {"container":"DIDNumbersTable_container__nzvHs","tableHeader":"DIDNumbersTable_tableHeader__yCQID"};